import React from 'react';
import theme from './style'
import PropTypes from 'prop-types';
import {
    DatePicker as DP,
} from '@material-ui/pickers';
import CheckIcon from '@material-ui/icons/Check';
import {useConfig} from "../../../context/configContext";
import { FormHelperText } from '@material-ui/core';

const DatePicker = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const { style, value, onChange, checkIcon, errorText } = props;
  const [selectedDate, setSelectedDate] = React.useState(value);

  const handleDateChange = (e) => {
    setSelectedDate(e);
    if (!checkIcon) {
      onChange(e);
    }
  }

  return (
    <div className={classes.datepickerContainer} style={style ? style : {}}>
      <DP
        className={classes.datepicker}
        disableToolbar
        autoOk
        format="YYYY-MM-DD"
        id="date-picker-inline"
        value={value}
        onChange={handleDateChange}
        clearable
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        error={Boolean(errorText)}
      />
      {checkIcon && <CheckIcon className='button' onClick={() => onChange(selectedDate)}/>} 
      {errorText && <FormHelperText error>{errorText}</FormHelperText>}
    </div>
  );
}

DatePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.oneOf([null])]),
    errorText: PropTypes.string,
}

DatePicker.defaultProps = {
  errorText: '',
};

export default DatePicker;
